import { render, staticRenderFns } from "./RepresentativeDetailed.vue?vue&type=template&id=64804b40&"
import script from "./RepresentativeDetailed.vue?vue&type=script&lang=js&"
export * from "./RepresentativeDetailed.vue?vue&type=script&lang=js&"
import style0 from "./RepresentativeDetailed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports